import * as React from 'react';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import mainImg from '../403.png';
import '../Forbidden.scss';

class ForbiddenScene extends React.Component {

    public render() {
        return <React.Fragment>
            <PageContent pageName="[ERROR] Forbidden">
                <PageBody>
                    <div className="forbidden-content">
                        <img src={mainImg} />
                        <h3>Looks like you're trying to access a page you don't have the right permissions for. <br/>
                            If you feel you've reach this page in error, please contact <a href="mailto: support@codagami.com">support</a> to 
                            have the necessary permissions added to your account.</h3>
                    </div>
                </PageBody>
            </PageContent>
        </React.Fragment>
    }
}

export { ForbiddenScene }